<template>
  <div>
    <training-organizer-info
      @reloadData="close"
      :formSchema="formSchema"
    ></training-organizer-info>
     <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->
    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="confirmModel" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmModel = false"
              >Disagree</v-btn
            >
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >
              Agree
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->
    <v-container>
      <v-card>
        <v-card-title>
          <span class="headline">Training Organizer Information List</span>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="items" :search="search">
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ ++props.index }}</td>
            <td class="text-xs-left">{{ props.item.org_type }}</td>
            <td class="text-xs-left">{{ props.item.name }}</td>
            <td class="text-xs-left">{{ props.item.address }}</td>
            <td class="text-xs-left">{{ props.item.location }}</td>
             <td class="text-xs-left">
               <tr>
                <span v-if="props.item.contact_person_1">a.{{ props.item.contact_person_1 }}<br></span>
                <span v-if="props.item.contact_person_2">b.{{ props.item.contact_person_1 }}</span>
              </tr>
            </td>
            <td class="text-xs-left">
              <tr>
                <span v-if="props.item.contact_phone_1">a.{{ props.item.contact_phone_1 }}<br></span>
                <span v-if="props.item.contact_phone_2">b.{{ props.item.contact_phone_2 }}</span>
              </tr>
            </td>
            <td class="text-xs-left">
              <tr>
                <span v-if="props.item.email_1">a.{{ props.item.email_1 }}<br></span>
                <span v-if="props.item.email_2">b.{{ props.item.email_2 }}</span>
              </tr>
            </td>
        
            <td>
              <span v-if="props.item.active" class="active">Yes</span>
              <span v-else class="in-active">No</span>
            </td>
            <td class="justify-center layout px-0">
              <v-btn
                icon
                class="mx-0"
                title="Details"
                @click="downloadFIle(props.item)"
              >
                <v-icon color="teal">view_module</v-icon>
              </v-btn>

              <v-btn
                icon
                class="mx-0"
                title="Edit"
                @click="editItem(props.item)"
              >
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <v-btn
                icon
                class="mx-0"
                title="Delete"
                @click="deleteItem(props.index, props.item.id)"
              >
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>

          <template slot="no-data" class="error">
       <div align="center"> No Data Found</div>
    </template>
        </v-data-table>
        <!-- <v-data-table item-key="name" class="elevation-1" loading loading-text="Loading... Please wait"></!-->
      </v-card>
    </v-container>
  </div>
</template>
<script>
const commonService = require("../../../services/common.service");

import { preFix } from "../../../vuex/api";
import trainingOrganizerInfo from "./_organizer_form";
import Axios from "axios";
import ServerPath from '../../../server-path/server-path';
export default {
  components: {
    trainingOrganizerInfo,
  },
  data: () => ({
    showForm: false,
    valid: true,
    dialog: false,
    dialogEditForm: false,

    search: "",
    totalItems: 0,
    loading: true,

    pagination: {
      sortBy: "id",
      descending: true,
    },

    selected: [],
    search: "",
    headers: [
      {
        text: "Sl#",
        align: "left",
        sortable: false,
        value: "id",
      },
      {
        text: "Organization Type",
        align: "left",
        sortable: false,
        value: "org_type",
      },
      { text: "Organization Name", align: "left", value: "name" },
      { text: "Address", value: "address" },
      { text: "Location", value: "location" },
      { text: "Contact Person Name", value: "contact_person_1" },
      { text: "Phone Number", value: "contact_phone_1" },
      { text: "Email", value: "email_1" },
      { text: 'Active', value: 'active' },
      { text: "Actions", value: "", align:"center"},
    ],
    items: [],

    formSchema: {
      id: "",
      code: "",
      name: "",
      org_type: "",
      org_origin: "",
      address: "",
      location: "",
      contact_person_1: "",
      contact_phone_1: "",
      email_1: "",
      contact_person_2: "",
      contact_phone_2: "",
      email_2: "",
      active:""
    },
    delete_id: "",
    row_index: "",
    dialog2: false,
    snackbar: false,
    color: "success",
    mode: "",
    timeout: 3000,
    left: "left",
    message: "",
    confirmModel: false,
    select: null,
    instituteList: [],

    typelist: [],

    SnackbarVal: {
      snackbar: false,
      color: "success",
      message: "",
    },
    instituteShow: true,
  }),

  computed: {
    userRole() {
      let role = this.$store.getters.get_USER_ROLE_DATA;
      this.showForm = role.saveButton;
      return role;
    },
  },

  methods: {
    downloadFIle(item){
      let query_Data2 = item.id;
      //let parameters = new URLSearchParams({ ...query_Data2}).toString();
      let route = ServerPath.serverPath+'/org_details?id=' + query_Data2;
      window.open(route, '_blank');
    },
    getDataFromApi() {
      commonService.getAllData("training_organizer").then((res) => {
        this.items = res.data;
        this.loading = false;
      });
    },

    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    validateBeforeSubmit(e) {},
    reloadData(message) {
      this.showForm = this.userRole.saveButton;
      if(message != 0){
          
          this.getDataFromApi();
      }   
      this.message = message.message
      this.snackbar = true  
    },

    editItem(item) {
      this.formSchema = item;
      this.showForm = true;
      window.scrollTo({
        // scroling to top
        top: 0,
        left: 100,
        behavior: "smooth",
      });
    },

    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.confirmModel = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "training_organizer").then((res) => {
        if (res.status == 1) {
          this.items.splice(row_index, 1);
          this.getDataFromApi();
        } else {
          this.SnackbarVal.color = "error";
        }
        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;

        this.confirmModel = false;
        this.dialog2 = false;
      });
    },

    close(res) {
      let $this = this;
      if (res.status == 1) {
        if (res.action == "add") {
          $this.items.unshift({ ...res.data });
        }
        if (res.action == "edit") {
          let findindex = this.items.findIndex(
            (item) => item.id == res.data.id
          );
          this.row_index = findindex;
          this.$set(this.items, this.row_index, { ...res.data });
          this.row_index = "";
          this.formSchema.id = 0;
        }
        window.scrollTo({
          left: 0,
          top:
            document.body.scrollHeight || document.documentElement.scrollHeight,
          behavior: "smooth",
        });
      }
      this.SnackbarVal.color = "success";
      this.SnackbarVal.message = res.message;
      this.SnackbarVal.snackbar = true;
    },
  },

  mounted() {
    this.getDataFromApi();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/training/training_organizer_info/_organizer_list.vue